import { features } from '@/mocks/homeData';

const iconColors = [
  'text-primary-500 bg-primary-50',
  'text-accent-500 bg-accent-50',
  'text-secondary-700 bg-secondary-100',
  'text-primary-600 bg-primary-50',
  'text-accent-600 bg-accent-50',
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-3">
          为什么选择91免费
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-12 max-w-xl mx-auto">
          五大核心优势，打造极致免费看片体验
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
          {features.map((feature, i) => (
            <div
              key={feature.title}
              className="bg-background-50 rounded-lg p-6 flex flex-col items-center text-center"
            >
              <div className={`w-14 h-14 rounded-full flex items-center justify-center mb-4 text-2xl ${iconColors[i % iconColors.length]}`}>
                <i className={feature.icon}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}